// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".batchAddFee[data-v-7d75f8f8] {\n  padding: 0 10px;\n}\n.batchAddFee .addTable[data-v-7d75f8f8] {\n  height: calc(100vh - 135px);\n  overflow-y: scroll;\n}\n.batchAddFee .footer[data-v-7d75f8f8] {\n  padding: 10px;\n  text-align: right;\n  border-top: 1px solid #ccc;\n}\n.el-form-item[data-v-7d75f8f8] {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
